import HeaderPortal from "components/portal/header-portal";
import { Button } from "ui/components/button";
import CreateItemButton from "components/buttons/create";
import EmployeeInput from "components/employee/input";
import { PermissionGate } from "permissions/components/gate";
import React from "react";
import { useState } from "react";
import { addEmployeeAccess } from "./api";
import { eventBus } from "utils/eventBus";
import { toast } from "sonner";
import { invalidateAllQueries } from "utils/utils";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";
import { DEFAULT_GITHUB_ROLE, GITHUB_ROLES } from "./constants";

const RepoEmplopyeesInputSheet = ({ employees, show, repository_url, repo_id }) => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedRole, setSelectedRole] = useState(DEFAULT_GITHUB_ROLE);
  const [isSubmitting, setIsSubmitting] = useState(false);

  
  console.log("selected rol", selectedRole);
  

  const handleConfirm = async () => {
    if (selectedEmployees.length > 0 && repository_url) {
      try {
        setIsSubmitting(true);
        const response = await addEmployeeAccess({
          repository_url,
          employees: selectedEmployees.map((emp) => emp.id),
          permission: selectedRole,
          role: selectedRole,
        });
        toast.success(response?.message || "Employees successfully added to GitHub repository! ✨");
        invalidateAllQueries();
        eventBus.emit("refresh:list", `github/repository/list_access${repo_id}`);
        return true;
      } catch (error) {
        const errorMessage = error?.response?.errors?.[0]?.message || error?.message || "Failed to add employees to GitHub repo";
        toast.error(errorMessage);
        console.error(error);
        return false;
      } finally {
        setIsSubmitting(false);
      }
    }
    return false;
  };

  function renderFooter({ setOpen, setSelectedEmployees }) {
    const currentRole = GITHUB_ROLES.find((r) => r.value === selectedRole);

    return (
      <div className="flex flex-col gap-3 w-full">
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-medium text-foreground">
            Role
          </label>
          <Select
            value={selectedRole}
            onValueChange={setSelectedRole}
            disabled={isSubmitting}
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select role">
                {currentRole?.label}
              </SelectValue>
            </SelectTrigger>
            <SelectContent>
              {GITHUB_ROLES.map((role) => (
                <SelectItem
                  key={role.value}
                  value={role.value}
                  className="py-2 cursor-pointer"
                >
                  <div className="flex flex-col gap-0.5 text-left">
                    <span className="font-medium text-sm text-foreground">
                      {role.label}
                    </span>
                    <span className="text-xs text-muted-foreground whitespace-normal leading-relaxed">
                      {role.description}
                    </span>
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <Button
          className="w-full"
          onClick={() => {
            handleConfirm();
            setSelectedEmployees([]);
            // setSelectedRole(DEFAULT_GITHUB_ROLE);
            setOpen(false);
          }}
        >
          Select
        </Button>
      </div>
    );
  }

  if (!show) {
    return null;
  }

  return (
    <>
      <EmployeeInput
        multiselect={true}
        value={selectedEmployees}
        onChange={setSelectedEmployees}
        allowRemoval={true}
        footer={renderFooter}
        excludedEmployeeIds={[
          ...((employees?.items || employees) || []).map((item) => item.employee.id),
          ...selectedEmployees.map((emp) => emp.id),
        ]}
        filters={{
          github_username: { _null: false },
        }}
      >
        <HeaderPortal>
          <PermissionGate
            rule="update:PC,JC"
            collection="jobs"
            showWhenDisabled={false}
          >
            <CreateItemButton>Employees</CreateItemButton>
          </PermissionGate>
        </HeaderPortal>
      </EmployeeInput>
    </>
  );
};

export default RepoEmplopyeesInputSheet;
